export const homeTaxInitData = {
  pdfList: [],
  taxData: {
    total: {
      determined: 0,
      taxPaid: 0,
      total: 0,
      type: 'minus',
    },
    list: [],
  },
};
export const homeTaxData = {
  pdfList: [
    {
      idx: 0,
      num: 1,
      docType: '전체',
      fileName: '고길동(750101) 2024년도 자료.pdf',
      recipient: '고길동 외 7명',
    },
  ],
  taxData: {
    total: {
      determined: 0,
      taxPaid: 50000,
      total: 350000,
      type: 'minus',
    },
    list: [
      {
        idx: 0,
        id: 'nationalPension',
        taxType: '국민연금/건강보험료(추가납부)	',
        type: 'a1',
        taxAccount: '840,000',
        addAccount: '0',
        applyAccount: '840,000',
      },
      {
        idx: 1,
        id: 'creditCard',
        taxType: '신용카드 등',
        type: 'a2',
        taxAccount: '840,000',
        addAccount: '0',
        applyAccount: '840,000',
      },
      {
        idx: 2,
        id: 'premium',
        taxType: '보혐료',
        type: 'a3',
        taxAccount: '840,000',
        addAccount: '0',
        applyAccount: '840,000',
      },
      {
        idx: 3,
        id: 'medicalExpenses',
        taxType: '의료비',
        type: 'a4',
        taxAccount: '840,000',
        addAccount: '0',
        applyAccount: '840,000',
      },
      {
        idx: 4,
        id: 'educationExpenses',
        taxType: '교육비',
        type: 'a5',
        taxAccount: '840,000',
        addAccount: '0',
        applyAccount: '840,000',
      },
      {
        idx: 5,
        id: 'donation',
        taxType: '기부금',
        type: 'a6',
        taxAccount: '840,000',
        addAccount: '0',
        applyAccount: '840,000',
      },
      {
        idx: 6,
        id: 'housingDeduction',
        taxType: '주택공제',
        type: 'a7',
        taxAccount: '840,000',
        addAccount: '0',
        applyAccount: '840,000',
      },
      {
        idx: 7,
        id: 'pensionSavings',
        taxType: '연금저축',
        type: 'a8',
        taxAccount: '840,000',
        addAccount: '0',
        applyAccount: '840,000',
      },
      {
        idx: 6,
        id: 'etcInput',
        taxType: '기타입력',
        type: 'a9',
        taxAccount: '840,000',
        addAccount: '0',
        applyAccount: '840,000',
      },
    ],
  },
};
